// extracted by mini-css-extract-plugin
export default {"spoiler":"Vfoh6aTx","_isBordered":"L32Tiibv","_isOpened":"aq1MBRpn","title":"KJc8pNnX","arrow":"qAxf6HIs","content":"d97uHSu3"};